import { useNavigate } from "react-router-dom";
import { useSupabaseQuery } from "@/hooks/useSupabaseQuery";
import { fetchActiveSignalCount, fetchSignalCountSeries } from "@/features/dashboard/api";
import { StatCard } from "@/components/ui/StatCard";
import { Skeleton } from "@/components/ui/Skeleton";
import { chartColors } from "@/components/charts/chartTheme";
import { formatCount } from "@/lib/format";

export function ActiveSignalsCard() {
  const navigate = useNavigate();
  const countQuery = useSupabaseQuery(() => fetchActiveSignalCount(), []);
  const seriesQuery = useSupabaseQuery(() => fetchSignalCountSeries(7), []);

  if (countQuery.isLoading || seriesQuery.isLoading) {
    return (
      <div className="stat-card stat-card-clickable" role="link" tabIndex={0} onClick={() => navigate("/signals")}>
        <Skeleton width="80px" height="0.6875rem" />
        <Skeleton width="60px" height="1.5rem" />
      </div>
    );
  }

  return (
    <StatCard
      label="Active signals"
      value={formatCount(countQuery.data ?? 0)}
      sparklineData={seriesQuery.data ?? []}
      sparklineColor={chartColors.brand}
      onClick={() => navigate("/signals")}
    />
  );
}
